export default __webpack_public_path__ + "static/Entenda0054-28b3338391f9b42d0b8175e7d53465db.jpg";